<template>
  <div class="bookings">
    <page-header title="Shipments" breadcrumb="Dashboard > Bookings & Shipments > Shipments" />

    <div class="bg-white p-3">
      <div v-if="userAccountType != 'solo_operator'" class="flex justify-between mt-3 mb-3">
        <div :style="{ 'background-color': '#7B858F10' }" class="flex ">
          <button :class="{ active: currentMethod == 'terminal-to-terminal' }" class="tab-item"
            @click="currentMethod = 'terminal-to-terminal', showPage = 'shipments'">
            <p>Terminal-to-Terminal</p>
          </button>
          <button :class="{ active: currentMethod == 'terminal-to-door' }" class="tab-item"
            @click="currentMethod = 'terminal-to-door', showPage = 'shipments'">
            <p>Terminal-to-Door</p>
          </button>
          <button :class="{ active: currentMethod == 'door-to-door' }" class="tab-item"
            @click="currentMethod = 'door-to-door', showPage = 'shipments'">
            <!-- <p>Door-to-Door(inter-state)</p> -->
            <p>Door-to-Door</p>
          </button>
          <button hidden :class="{ active: currentMethod == 'door-to-door-within' }" class="tab-item"
            @click="currentMethod = 'door-to-door-within', showPage = 'shipments'">
            <p>Door-to-Door(intra-state)</p>
          </button>
          <button :class="{ active: showPage == 'requests' }" class="tab-item"
            @click="showPage = 'requests', currentMethod = ''">
            <p>Requests</p>
          </button>
        </div>

      </div>

      <div v-if="showPage == 'shipments'">
        <div class="flex justify-between mt-4 mb-3">
          <div :style="{ 'background-color': '#7B858F10' }" class="flex ">
            <button hidden :class="{ active: currentTab == 'draft' }" class="tab-item" @click="currentTab = 'draft'">
              <p>Draft</p>
            </button>
            <button :class="{ active: currentTab == 'pending' && showDispatch == false }" class="tab-item"
              @click="currentTab = 'pending', showDispatch = false">
              <p>Active Shipments</p>
            </button>
            <button v-if="userAccountType != 'solo_operator' && currentMethod !== 'door-to-door-within'"
              :class="{ active: currentTab == 'scheduled' }" class="tab-item" @click="currentTab = 'scheduled'">
              <p>Scheduled Shipments</p>
            </button>
            <button :class="{ active: currentTab == 'completed' }" class="tab-item"
              @click="currentTab = 'completed', showDispatch = false">
              <p>Completed Shipments</p>
            </button>
            <button v-if="userAccountType != 'solo_operator' && currentMethod !== 'door-to-door-within'"
              :class="{ active: currentTab == 'customer-bound' && showDispatch == true }" class="tab-item"
              @click="currentTab = 'customer-bound', showDispatch = true">
              <p>Customer-Bound Dispatch</p>
            </button>
          </div>

          <!-- <div class="flex justify-end">
              <button class="mr-4 px-5 py-2 rounded-md font-bold text-white pale-blue" @click="$router.push({ name : 'BookingRequests'})">All Requests</button>
          </div> -->
        </div>

        <div class="topline-wrapper px-2 py-2 ">
          <div class="topline px-3 flex flex-wrap justify-start">
            <div class="flex gap-2 topline-child">
              <CummulativeIcon />
              <p class="mt-2 font-bold">{{ showDispatch ? 'Dispatch' : 'Cummulative' }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">SHIPMENTS (QTY)</p>
              <p class="topline-value">{{ shippingAnalytics.totalShipmentCount }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">DISTANCE (M)</p>
              <p class="topline-value">{{ shippingAnalytics.totalShipmentDistance }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">GROSS WEIGHT(KG)</p>
              <p class="topline-value">{{ shippingAnalytics.totalShipmentWeight }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">REVENUE</p>
              <p class="topline-value">₦{{ shippingAnalytics.totalShipmentRevenue }}</p>
            </div>
          </div>

          <div v-if="!showDispatch" class="topline px-3 flex flex-nowrap justify-start">
            <div class="flex gap-2 topline-child">
              <TopChannelsIcon />
              <p class="mt-2 font-bold">Top Channels</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">PLATFORM (QTY)</p>
              <p class="topline-value">{{ Number(shippingAnalytics.totalPlatform) }}</p>
            </div>

            <div v-if="userAccountType != 'solo_operator'" class="topline-child">
              <p class="topline-header">WALK-IN (QTY)</p>
              <p class="topline-value">{{ shippingAnalytics.totalWalkIn }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">JUMIA (QTY)</p>
              <p class="topline-value">0</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">CORNIE HEALTH (QTY)</p>
              <p class="topline-value">0</p>
            </div>

          </div>

          <div class="topline px-3 pb-2 flex flex-wrap justify-start">
            <div class="flex gap-2 topline-child">
              <TopRoutesIcon />
              <p class="mt-2 font-bold">Top {{ showDispatch ? 'Destinations' : 'Routes' }}</p>
            </div>

            <!-- When showDispatch = true -->
            <template v-if="showDispatch">
              <div class="topline-child" v-for="SS in shippingAnalytics.shippingServices" :key="SS.shippingServiceId">
                <p class="topline-header">{{ SS.routeName + ' (QTY)' }}</p>
                <p class="topline-value">{{ SS.totalAmountPaid }}</p>
              </div>
            </template>

            <!-- When showDispatch = false -->
            <template v-else>
              <div class="topline-child" v-for="(topRoute, index) in shippingAnalytics.topRoutes" :key="index">
                <p class="topline-header">{{ topRoute.routeName + ' (QTY)' }}</p>
                <p class="topline-value">{{ topRoute.totalShipments }}</p>
              </div>
            </template>

          </div>
        </div>

        <div class="group-options-select mb-4 mt-5">
          <div class="flex items-center justify-between">
            <div class="flex justify-start gap-4">
              <el-dropdown>
                <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
                  :class="{ 'shadow-sm': sortList }" style="width: 40px;height: 40px;background-color: #F7FAFD;">
                  <sort-icon />
                </button>
                <el-dropdown-menu slot="dropdown" placement="right-end">
                  <el-dropdown-item disabled>SORT BY</el-dropdown-item>

                  <el-dropdown-item>
                    <button @click="sortOrder = 'ASC'" class="flex items-center">
                      <span class="ml-2">ASC</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button @click="sortOrder = 'DESC'" class="flex items-center">
                      <span class="ml-2">DESC</span>
                    </button>
                  </el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

              <div v-if="!isIntrastateDoorToDoor" class="table__search-input-wrapper" style="width: 470px">
                <span class="pr-2 opacity-50">
                  <search-icon />
                </span>
                <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
                <img src="@/assets/images/icons/search.svg" alt="search icon" @click="showFilterModal = true"
                  class="cursor-pointer" />
              </div>


              <div v-else class="table__search-input-wrapper" style="width: 470px">
                <span class="pr-2 opacity-50">
                  <search-icon />
                </span>
                <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
                <img src="@/assets/images/icons/search.svg" alt="search icon" @click="setModal"
                  class="cursor-pointer" />
                <!-- <img src="@/assets/images/icons/search.svg" alt="search icon" @click="showFilterModal = true" class="cursor-pointer"/> -->
              </div>

            </div>

            <div class="date-picker flex items-center justify-center">
              <el-date-picker hidden type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
                v-model="startDate" />

              <el-date-picker hidden type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />


              <button v-if="currentMethod == 'terminal-to-door' && showDispatch == false"
                :style="{ height: '42px', opacity: isConsolidateDisabled ? 0.65 : 1 }"
                :disabled="selectedShipments.length == 0" :class="{ 'cursor-default': isConsolidateDisabled }"
                class="mr-4 px-5 rounded-md font-bold text-white pale-blue" @click="handleConsolidation">
                Consolidate
              </button>

              <button v-if="currentMethod == 'terminal-to-door' && showDispatch == false"
                :style="{ height: '42px', opacity: isDIspatchDisabled ? 0.65 : 1 }"
                :disabled="selectedShipments.length == 0" :class="{ 'cursor-default': selectedShipments.length == 0 }"
                class="mr-4 px-5 rounded-md font-bold text-white pale-blue"
                @click="handleDIspatchAction">Dispatch</button>

              <button :disabled="!isConDispHandoffDisapbled && isDIspatchDisabled"
                v-if="currentMethod == 'door-to-door' && showDispatch == false"
                :class="[`py-2 px-3 bg-black-default rounded-lg mr-4`]">
                <el-dropdown class="text-black" trigger="click">
                  <button class="btn_action">
                    <span class="mr-3 pr-2">Consolidate</span>
                    <!-- <img src="./svg/both-arrow.svg" class="w-4" /> -->
                  </button>
                  <el-dropdown-menu v-if="!isConsolidateDisabled || !isDIspatchDisabled || !isHandOffDisabled" class="w-36" slot="dropdown">
                    <el-dropdown-item cl v-if="!isConsolidateDisabled && selectedShipments.length > 1">
                      <button @click="handleConsolidation" class="text-base whitespace-nowrap">Consolidate</button>
                    </el-dropdown-item>

                    <el-dropdown-item v-if="!isDIspatchDisabled">
                      <button @click="handleDIspatchAction">Dispatch</button>
                    </el-dropdown-item>

                    <el-dropdown-item v-if="!isHandOffDisabled">
                      <button>Hand off</button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </button>

              <button v-if="showDispatch == true"
                :style="{ height: '42px', opacity: selectedShipments.length == 0 ? 0.65 : 1 }"
                :disabled="selectedShipments.length == 0" :class="{ 'cursor-default': selectedShipments.length == 0 }"
                class="mr-4 px-5 rounded-md font-bold text-white pale-blue"
                @click="showDispatchDialog = true">Dispatch</button>

              <base-button v-if="!showDispatch" @click="showNewBookingModal = true" text="New Booking" />

              <base-button v-if="showDispatch" @click="openModal" text="Hand Off" />
            </div>
          </div>
        </div>

        <bookings-table :loading="loading" @booking-action-completed="refetchBookings" :bookings="bookings"
          :currentTab="currentTab" :currentMethod="currentMethod" @refetchBookings="refetchBookings"
          @newSelect="resetSelected($event)" v-if="!isIntrastateDoorToDoor" :resetCheckBox="resetCheckBox"
          :selectedShipments="selectedShipments" />

        <BookingsTableDoorDoorIntraState v-else :loading="loading" @booking-action-completed="refetchBookings"
          :bookings="bookings" :currentTab="currentTab" :currentMethod="currentMethod"
          @refetchBookings="refetchBookings" @newSelect="resetSelected($event)" :pageSize="pageSize"
          :queryString="queryString" :pageNumber="pageNumber" :setTotalBooking="setTotalBooking" />



        <div class="mt-3">
          <pagination-control :total="totalBookings" :pageNumber="pageNumber" @pageSize="pageSize = $event"
            @pageNumber="pageNumber = $event" />
        </div>
      </div>

      <!-- <div v-if="selectedShipments.length > 0"> -->
      <div>
        <el-dialog :visible.sync="showDispatchDialog" width="40%">
          <h2 class="text-2xl font-semibold">Dispatch</h2>
          <div class="flex items-start justify-between mb-4">
            <div>
              <div>Dispatch ID: 457906-04</div>
            </div>
            <div>
              <div>
                <p>Item Count: <span>{{ selectedShipments.length }} (GW {{ totalShippmentWeight }}KG)</span></p>
              </div>
            </div>

          </div>

          <div>
            <div class="flex justify-between">
              <p>{{ selectedShipments.length }} Customers, {{ totalPackage }} Packages(s)</p>
              <div @click="showItemsDiv = !showItemsDiv">
                <ArrowDownIcon class="cursor-pointer " />
                <ArrowUpIcon />
              </div>

            </div>
            <div v-if="showItemsDiv">

              <div v-for="item in selectedShipments" :key="item.id" class="mt-3 align-middle">
                <p class="font-semibold">{{ shipmentDetails(item).receiver &&
                  shipmentDetails(item).receiver.contactName ?
                  shipmentDetails(item).receiver.contactName :
                  "N/A" }}</p>
                <div class="flex justify-between gap-4">
                  <p :style="{ 'color': '#383F5160' }" class="">{{ shipmentDetails(item).receiver &&
                    shipmentDetails(item).receiver.mobile ? shipmentDetails(item).receiver.mobile :
                    'N/A' }}
                  </p>
                  <p class="flex-1" :style="{ 'color': '#383F5160' }">{{ shipmentDetails(item).receiver &&
                    shipmentDetails(item).receiver.address ?
                    shipmentDetails(item).receiver.address.name :
                    "N/A" }}</p>
                  <p :style="{ 'color': '#383F5160' }">{{ shipmentDetails(item).packages &&
                    shipmentDetails(item).packages.length ? shipmentDetails(item).packages.length : '0' }} Item(s)</p>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <div>
                <label class="mb-1">Destination</label>
                <el-select v-model="destination" placeholder="" disabled>
                </el-select>
              </div>
            </div>

            <div class="mt-3">
              <div>
                <label class="mb-1">Driver/Dispatcher</label>

                <el-select v-model="driver" placeholder="Select Driver">
                  <el-option v-for="driver in drivers" :key="driver.driverId" :label="driverLabel(driver)"
                    :value="driver.driverId && driver.driverId">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="flex justify-end mt-5" style="height: 80px">

            <div class="h-full">
              <button class="h-full font-semibold" style="width: 120px" @click="showDispatchDialog = false">
                Cancel
              </button>

              <primary-button :loading="dispatchLoading" :disabled="disableSaveDispatch" @click="dispatch"
                class="h-full bg-primary-yellow rounded font-semibold !text-black" style="width: 120px;height: 40px"
                buttonText="Save">

              </primary-button>
            </div>
          </div>


        </el-dialog>
      </div>


      <div v-if="showPage == 'requests'">
        <BookingsRequest />
      </div>

      <TTsearchfilter @appliedRef="appliedReference" @filteredVal="filteredVal" :show-modal="showFilterModal"
        @close-modal="showFilterModal = false" :loading="loading" @booking-action-completed="refetchBookings"
        :bookings="bookings" :bookingData="bookingData" :currentTab="currentTab" :currentMethod="currentMethod"
        @refetchBookings="refetchBookings" @newSelect="resetSelected($event)" v-if="!isIntrastateDoorToDoor" />


      <!-- <DDsearchfilter v-if="showIntraStateModal" @close-modal="showIntraStateModal = false" :loading="loading" @booking-action-completed="refetchBookings" :bookings="bookings"
          :bookingData="bookingData" :currentTab="currentTab" :currentMethod="currentMethod"
          @refetchBookings="refetchBookings" @newSelect="resetSelected($event)" /> -->
      <booking-modal :show-modal="showModal" @close-modal="showModal = false" />
      <NewBookinfModal :showModal="showNewBookingModal" @close-modal="showNewBookingModal = false" />
    </div>

  </div>
</template>

<script>
import moment from "moment";
import BookingModal from "./BookingSearchModal";
import BookingsTable from "./BookingsTable";
import BookingsTableDoorDoorIntraState from "./BookingsTableDoor_Door_IntraState.vue";
import PaginationControl from "@/components/UI/pagination";
import PageHeader from "@/components/UI/NewPageHeader";
import CummulativeIcon from "@/components/UI/svgs/CummulativeIcon.vue"
import TopChannelsIcon from "@/components/UI/svgs/TopChannelsIcon.vue"
import TopRoutesIcon from "@/components/UI/svgs/TopRoutesIcon.vue"
import BookingsRequest from "@/views/3pl/Operations/Requests/BookingRequests.vue"
// import ArrowDownIcon from "@/components/UI/svgs/ArrowDownIcon.vue"
import debounce from "@/utilities/debounce";
import TTsearchfilter from "../Modals/TTsearchfilter.vue";
// import DDsearchfilter from "../Modals/TTsearchfilter.vue";
import NewBookinfModal from "@/components/Ondemand/Bookings/modals/NewBookinfModal.vue";

export default {
  components: {
    TTsearchfilter,
    // DDsearchfilter,
    PageHeader,
    BookingModal,
    BookingsTable,
    PaginationControl,
    CummulativeIcon,
    TopChannelsIcon,
    TopRoutesIcon,
    BookingsRequest,
    // ArrowDownIcon,
    NewBookinfModal,
    BookingsTableDoorDoorIntraState
  },
  data() {
    return {
      showNewBookingModal: false,
      showFilterModal: false,
      // showIntraStateModal: false,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalBookings: 1,
      currentTab: "pending",
      currentMethod: 'terminal-to-terminal',
      sortList: false,
      startDate: null,
      // topRoutes: null,
      endDate: null,
      showModal: false,
      shipmentLayout: "table",
      isSelectShipmentLayout: false,
      bookings: {},
      queryString: null,
      requestLoading: false,
      estimate: 0.0,
      newEstimate: {
        takeoff: "",
        delivery: "",
        shipmentType: "package",
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        apiKey: "AIzaSyAys4Gc-dGXZmLn_zvNPMie_7d6oZicCuQ",
        quantity: 0,
      },
      sortOrder: "DESC",
      sortColumn: "",
      selectedShipments: [],
      showPage: 'shipments',
      showDispatch: false,
      showDispatchDialog: false,
      drivers: [],
      destination: "",
      canConsolidate: false,
      canDispatch: false,
      canHandoff: false,
      driver: "",
      showItemsDiv: true,
      shippingAnalytics: {},
      dispatchLoading: false
    };
  },
  computed: {
    isConDispHandoffDisapbled() {
      return (!this.isDIspatchDisabled || !this.isConsolidateDisabled || !this.isHandOffDisabled)
    },
    isHandOffDisabled() {
      return !this.canHandoff || this.selectedShipments.length == 0;
    },
    isDIspatchDisabled() {
      return !this.canDispatch || this.selectedShipments.length == 0;
    },
    isConsolidateDisabled() {
      return !this.canConsolidate || this.selectedShipments.length == 0;
    },
    disableSaveDispatch() {
      return this.driver == "" || this.destination == ""
    },
    isIntrastateDoorToDoor() {
      return this.currentMethod === "door-to-door-within"
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    },
    userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
    totalPackage() {
      return (this.selectedShipments || []).reduce((sum, shipment) => {
        const details = this.shipmentDetails(shipment)
        return sum + ((details && details.packages) ? details.packages.length : 0)
      }, 0)
    },
    totalShippmentWeight() {
      const totalWeight = (this.selectedShipments || []).reduce((shipmentSum, shipment) => {
        const packageWeight = (this.shipmentDetails(shipment)?.packages || []).reduce((pkgSum, pkg) => {
          return pkgSum + (Number(pkg?.estimatedWeight) * Number(pkg?.quantity || 1))
        }, 0)

        return shipmentSum + packageWeight
      }, 0)
      return totalWeight;
    },
    dispatchRecieverPayload() {
      return {
        orgId: this.$store.getters?.user?.orgId,
        userId: this.$store.getters?.userId,
        receiverIds: this.selectedShipments,
        fleetId: this.drivers.find((item) => item.id == this.driver)?.id,
      }
    }
  },
  watch: {
    currentMethod() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    currentTab: {
      handler() {
        this.pageNumber = 1;
        this.startDate = null;
        this.endDate = null;

        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          startDate: this.startDate,
          endDate: this.endDate,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      },
      immediate: true,
    },

    sortOrder() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    },
    queryString: debounce(function () {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    }, 500),
    locationId() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        pageSize: this.pageSize,
        search: this.queryString,
        sortColumn: this.sortColumn,
      });
    },
    startDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          search: this.queryString,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },

    endDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },

    pageSize() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },

    pageNumber() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },

    shipmentLayout() {
      this.isSelectShipmentLayout = false;
    },
    selectedShipments(val) {
      if (val.length > 0 && this.showDispatch) {
        // this.showDispatchDialog = true
      } else {
        this.showDispatchDialog = false
      }
    },

  },
  mounted() {
    this.getLocationsManaged();
    this.gettingAllLocations();
    if (this.$route.query.consolidationId) {
      this.showModal = false;
    }

    if (this.$route.query.currentTab) {
      this.currentTab = this.$route.query.currentTab;
    }

    this.getAnalytics();

    this.getDriver();
  },
  methods: {
    handleDIspatchAction() {
      if (!this.canDispatch) {
        this.generateToast("Only Received at origin Terminal, Arrived at destination terminal or Consolidated items can be dispatched", "error");
        return;
      }
      this.showDispatchDialog = true
    },
    handleConsolidation() {
      if (!this.canConsolidate) {
        this.generateToast("Only Received at origin Terminal or Arrived at destination terminal items can be consolidated", "error");
        return;
      }

      this.$router.push({
        name: "NewConsolidation",
        params: { preSelect: this.selectedShipments, preselectDetails: this.selectedShipments.map((item) => this.shipmentDetails(item)) },
      });
    },
    driverLabel(driver) {
      return driver?.driver?.firstname + ' ' + driver?.driver?.lastname + ' (' + driver?.driver?.mobile_no + ')'
    },
    getTopRouteQty(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      return route?.topRoutes?.map((item) => Number(item.totalShipments)).reduce((item, sum) => sum + item, 0)
    },
    getTopRouteDistance(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      return route?.topRoutes?.map((item) => Number(item.totalDistance)).reduce((item, sum) => sum + item, 0)
    },
    getTopRouteGrossWgt(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      return route?.topRoutes?.map((item) => Number(item.totalGrossWeight)).reduce((item, sum) => sum + item, 0)
    },
    getTopRouteRevenue(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      const totalRevenue = route?.topRoutes?.map((item) => Number(item.totalRevenue)).reduce((item, sum) => sum + item, 0)
      return totalRevenue.toLocaleString('en-US', {
        minimumFractionDigits: 2,  // Ensure 2 decimal places
        maximumFractionDigits: 2   // Optional: Ensures no more than 2 decimal places
      })
    },
    setModal() {
      this.showIntraStateModal = true
    },
    appliedReference(filteredVal) {
      this.queryString = filteredVal
    },
    filteredVal(val) {
      this.channels = val
      this.getFilteredBookings()
    },
    setTotalBooking(val) {
      this.totalBookings = val
    },
    consolidateAction() {
      const allowedStatuses = [
        "received_at_origin_terminal",
        "arrived_at_destination_terminal",
        "pending",
      ];

      const statuses = this.selectedShipments.map(
        (item) => this.shipmentDetails(item).orderStatus
      );

      const allAllowed = statuses.every((status) =>
        allowedStatuses.includes(status)
      );

      const allSame = new Set(statuses).size === 1;

      this.canConsolidate = allAllowed && allSame;
    },
    dispatchAction() {
      const allowedDispatchStatuses = [
        "received_at_origin_terminal",
        "arrived_at_destination_terminal",
        "consolidated",
      ];

      const statuses = this.selectedShipments.map(
        (item) => this.shipmentDetails(item).orderStatus
      );

      const allAllowed = statuses.every((status) =>
        allowedDispatchStatuses.includes(status)
      );

      const allSame = new Set(statuses).size === 1;

      this.canDispatch = allAllowed && allSame;
    },
    handoffAction() {
      const allowedHandoffStatuses = [
        "received_at_origin_terminal",
        "in_transit_to_destination_terminal",
        "arrived_at_destination_terminal",
      ];

      const statuses = this.selectedShipments.map(
        (item) => this.shipmentDetails(item).orderStatus
      );

      const allAllowed = statuses.every((status) =>
        allowedHandoffStatuses.includes(status)
      );

      const allSame = new Set(statuses).size === 1;

      this.canHandoff = allAllowed && allSame;
    },

    resetSelected(selected) {
      this.selectedShipments = selected;
      this.destination = this.selectedShipments.map((item) => this.shipmentDetails(item)?.receiver?.address?.name).join(', ')
      this.consolidateAction();
      this.dispatchAction();
      this.handoffAction();
    },
    openModal() {
      this.showModal = true;
    },
    refetchBookings() {
      this.loading = true;
      this.getBookings({
        status: this.currentTab,
        shippingMethod: this.currentMethod,
        terminalId: this.locationId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    shipmentDetails(id) {
      if (this.bookings.length > 0) {
        return this.bookings.find(x => x.id == id) || {};
      }

    },
    async getLocationsManaged() {
      try {
        this.loading = true;
        const response = await this.$_getLocationsManaged();
        this.$store.dispatch("saveManagedLocations", response.data.data);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    getTakeOff(addressData) {
      this.newEstimate.takeoff = addressData?.route;
    },
    getDelivery(addressData) {
      this.newEstimate.delivery = addressData?.route;
    },
    disabled() {
      return this.$store.state.authentication.env == "staging" ? true : false;
    },
    gettingAllLocations() {
      try {
        this.$_getAllLocations().then((response) => {
          this.$store.dispatch(
            "saveOrgLocations",
            response.data.data.locations
          );
        });
      } catch (error) {
        this.handleError(error);
      }
    },

    async dispatchReciever() {
      this.dispatchLoading = true;
      try {
        await this.$_dispatchRecievers(this.dispatchRecieverPayload);
        this.showDispatchDialog = false;
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          startDate: this.startDate,
          endDate: this.endDate,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } catch (error) {
        this.handleError(error)
      } finally {
        this.dispatchLoading = false
      }
    },
    async getBookings(data) {
      try {
        this.loading = true;

        if (this.locationId) {
          this.selectedShipments = [];
          const { data: response } = await this.$_getBookingsByTerminalNew(this.locationId, data);
          this.bookings = response.data.data;
          this.totalBookings = response.data;
        }

      } catch (error) {
        if (this.locationId) {
          this.handleError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async getAnalytics() {
      try {
        this.loading = true;
        const { data: response } = await this.$_getBookingToplineAnalytics();
        this.shippingAnalytics = response.data
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    // async getTopRoutes() {
    //   try {
    //     this.loading = true;
    //     const { data: response } = await this.$_getShippingTopRoutes();
    //     this.topRoutes = response.data.topRoutes
    //   } catch (error) {
    //     this.handleError(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    dispatch() {
      this.dispatchReciever();
    },
    async getDriver() {
      try {
        const { data: response } = await this.$_getOutboundDispatcher();
        this.drivers = response.data
      } catch (error) {
        this.handleError(error);
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.btn_action {
  @apply font-semibold flex items-center justify-between rounded-2xl text-white
}

.footer_contain {
  @apply flex justify-end mt-5 mb-2 gap-4;

  .save_btn {
    @apply bg-primary-yellow font-semibold px-4 py-2 rounded-md;
  }
}

.el-date-editor.el-input {
  margin-bottom: 0;
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #10233e6e;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>

<style lang="scss" scoped>
.estimate-form-wrapper {
  padding: 1rem;
  background: #ffffff;
  /* cards */

  box-shadow: 0px 20px 40px #edf0f5;
  border-radius: 5px;
}

.topline-wrapper {
  border: 1px solid gray;
  border-style: dashed;
  border-radius: 5px;
  margin-top: 30px;
  box-shadow: 10px 10px 30px rgb(227, 224, 224);

  .topline {
    background-color: #F2F7FC;
    border-radius: 10px;
    margin-top: 7px;
    height: 72px;
    padding-top: 16px;
    vertical-align: middle;

    .topline-child {
      border-right: 1px dashed #4142455C;
      height: 40px;
      padding: 0px 20px 0px 20px;
      width: 20%;

      .topline-header {
        color: #7A90A7;
        font-weight: 600;
        font-size: 14px;
      }

      .topline-value {
        color: #10233E;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}


.header p {
  color: #1f1f1f;
  font-size: 1.35rem;
  padding: 1rem 0.5rem;
  font-weight: 500;
}

.estimate-form {
  display: flex;
  flex-wrap: wrap;
}

.input-wrapper,
.calculate-button {
  width: 50%;
  padding: 0 0.5rem;

  .input {
    background: #fbfcfe;
    border: 1px solid #dae8f6;
    box-sizing: border-box;
    border-radius: 2px;
  }

  div {
    width: 50%;
  }
}

.shipment-type-select {
  width: 50%;
  padding: 0 0.5rem;
}

.vehicle-types {
  display: flex;
}

.vehicle-type {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0.5rem 0;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 5rem;

  small {
    color: #7a91a7;
    padding-top: 0.5rem;
    font-size: 0.7rem;
  }
}

.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 100%;
  margin-top: 3rem;
}

.shipment-action {
  height: 50%;
  border-radius: 10px;
  color: #ffffff;
  padding: 3.72rem 1rem;
}

.book-shipment-button {
  background: #0f9cda;
  margin-bottom: 1rem;
  background-image: url("../../../../../assets/images/booking-management/book-shipment-bg.png");
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;
}

.scheduled-shipments-button {
  background: #00c49a;
  background-image: url("../../../../../assets/images/booking-management/scheduled-shipment-bg.png");
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;
}

.estimate-result {
  width: 13.5rem;
  height: 2.75rem;
  background: linear-gradient(180deg,
      #e2ebfa 11.98%,
      rgba(226, 235, 250, 0) 51.56%,
      #e2ebfa 95.83%);
  border: 2px solid #2d9cdb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;

  span {
    color: #cad7f2;
    font-size: 1.3rem;
    padding-left: 0.5rem;
    font-weight: 500;
  }
}

.shipment-layout-select {
  right: 5.5rem;
  top: 1.5rem;
  z-index: 999;
  position: absolute;
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  padding: 0.75rem;
  width: 10rem;
}

.label {
  font-size: 0.7rem;
}

.shipment-layout-select .selected {
  color: #e59506;
}

.dimension-input {
  width: 4rem;
}

.dimension-input-wrapper {
  width: 100% !important;
}

.pale-blue {
  background-color: #10233e;
}
</style>
